export type ViewMode = 'entries' | 'calendar' | 'settings' | 'support' | 'faq' | 'updates' | 'reporting' | 'docs';

export const routeToView: Record<string, ViewMode> = {
  entries: 'entries',
  calendar: 'calendar',
  settings: 'settings',
  support: 'support',
  faq: 'faq',
  updates: 'updates',
  reporting: 'reporting',
  docs: 'docs',
};

export function getViewFromPath(pathname: string): ViewMode | undefined {
  const segments = pathname.split('/').filter(Boolean);
  return routeToView[segments[0]];
}

export const viewToRoute: Record<ViewMode, string> = {
  entries: '/entries',
  calendar: '/calendar',
  settings: '/settings',
  support: '/support',
  faq: '/faq',
  updates: '/updates',
  reporting: '/reporting',
  docs: '/docs',
};
